import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { SUPPORTED_LANGUAGES, LANGUAGE_FLAGS } from '../data/supportedLanguages';
import './SupportedLanguagesModal.css';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const SupportedLanguagesModal: React.FC<Props> = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <motion.div
      className="modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="language-modal"
        initial={{ opacity: 0, scale: 0.96, y: 40 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.96, y: 40 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Supported Languages</h3>
          <button type="button" className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content">
          <p>Substyle supports the following languages:</p>
          <div className="languages-grid">
            {SUPPORTED_LANGUAGES.map((language) => (
              <div key={language.lang} className="language-item">
                <span className="language-flag">
                  {LANGUAGE_FLAGS[language.lang] ?? ''}
                </span>
                <span className="language-name">{language.name}</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SupportedLanguagesModal;
